import { render, staticRenderFns } from "./borrowInvoiceDemo.vue?vue&type=template&id=809d4446&scoped=true&"
import script from "./borrowInvoiceDemo.vue?vue&type=script&lang=js&"
export * from "./borrowInvoiceDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "809d4446",
  null
  
)

export default component.exports